module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Top', {
    attrs: {
      "title": "Дистанционное обучение",
      "subtitle": "Нажмите на интересующий вас день, чтобы увидеть подробности."
    }
  }, [_c('Selector', {
    attrs: {
      "slot": "filter",
      "isNoDate": _vm.isNoDate
    },
    on: {
      "selected": _vm.typeContentStyle
    },
    slot: "filter"
  }), _c('CalendarFilter', {
    attrs: {
      "monthValue": _vm.monthValue,
      "monthYear": _vm.monthYear
    },
    on: {
      "monthChange": _vm.monthChange,
      "yearChange": _vm.yearChange,
      "typeChange": _vm.typeChange
    }
  }), (_vm.isLoading) ? _c('LoadingSpinner', {
    attrs: {
      "size": 100
    }
  }) : [(_vm.isError) ? _c('Infotext', {
    attrs: {
      "text": "Ошибка"
    }
  }) : [(_vm.isCalendar) ? _c('CalendarBlock', {
    attrs: {
      "items": _vm.items,
      "month": _vm.month,
      "year": _vm.year
    },
    on: {
      "openPopup": _vm.openPopup,
      "prevMonth": _vm.prev,
      "nextMonth": _vm.next
    }
  }, [(_vm.isPopup) ? _c('CalendarPopup', {
    attrs: {
      "slot": "blockPopup"
    },
    on: {
      "close": _vm.closePopup
    },
    slot: "blockPopup"
  }, [_c('Info', {
    attrs: {
      "id": _vm.id,
      "items": _vm.popupItems,
      "noborder": true
    }
  })], 1) : _vm._e()], 1) : _c('ListBlock', {
    attrs: {
      "items": _vm.items,
      "month": _vm.month,
      "year": _vm.year
    }
  })]]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a93f28f","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/remote-edu/calendar/Calendar.vue
// module id = 582a7abf152080979b7f
// module chunks = 7